import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import NavigationSystem from '../navigation/NavigationSystem';
import './Header.css';

const NAV_ITEMS = [
  { to: '/',           label: 'Home' },
  { to: '/approach',   label: 'Approach' },
  { to: '/principles', label: 'Principles' },
  { to: '/history',    label: 'History' },
];

const Header = () => {
  return (
    <header className="topbar">
      <div className="frame topbar__inner">
        <Link to="/" className="topbar__brand" aria-label="RussellStone Lighthouse — home">
          <img
            src="/img/lh_logo-white-880x284.webp"
            srcSet="/img/lh_logo-white-600x193.webp 600w, /img/lh_logo-white-880x284.webp 880w, /img/lh_logo-white-1200x387.webp 1200w"
            sizes="200px"
            alt="RussellStone Lighthouse"
          />
        </Link>

        <nav className="topbar__nav" aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => (isActive ? 'is-active' : undefined)}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/contact" className="topbar__cta">
          Start a conversation
        </Link>

        <NavigationSystem />
      </div>
    </header>
  );
};

export default Header;
